import { useParams, Link } from "react-router-dom";
import products from "../data/products";
import { useCart } from "../context/CartContext";

export default function ProductDetail(){
    const {id} = useParams();
    const product = products.find(p=>p.id === Number(id));
    const {addItem} = useCart();

    if(!product){
        return <div>
            <h3>Product not found.</h3>
            <Link
                to="/"
                className="btn btn-primary mt-3"
            >Back to shop</Link>
        </div>;
    }

    const handleAdd = _=>addItem(product, 1);

    return <div
        className="container"
    >
        <div
            className="row g-4"
        >
            <div
                className="col-md-6"
            >
                <img
                    src={product.img}
                    alt={product.name}
                    className="img-fluid rounded shadow-sm"                
                ></img>

            </div>
            <div
                
            ></div>

        </div>

    </div>;
}